module.exports = __webpack_public_path__ + "img/no-results-found.a5b064dd.png";